/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PutAwayFServ01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const putAwayFServ01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const putAwayFServ01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const putAwayFServ01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const putAwayFServ01ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const putAwayFServ01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const putAwayFServ01FetchPutAwayFServ01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const putAwayFServ01FetchPutAwayFServ01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const putAwayFServ01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const putAwayFServ01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const putAwayFServ01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const putAwayFServ01ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_SHOW_SYNC_SETTING_LOADING]: putAwayFServ01ShowSyncSettingLoading,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_SHOW_SYNC_SETTING_SUCCESS]: putAwayFServ01ShowSyncSettingSuccess,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_SHOW_BATCH_JOB_STATUS_SUCCESS]: putAwayFServ01ShowBatchJobStatusSuccess,

  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_RESET_TIMESTAMP]: putAwayFServ01ResetTimestamp,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_FETCH_PUT_AWAY_F_SERV01_LOADING]: putAwayFServ01FetchPutAwayFServ01Loading,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_FETCH_PUT_AWAY_F_SERV01_SUCCESS]: putAwayFServ01FetchPutAwayFServ01Success,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_ADD_SELECTED_DOCUMENTS]: putAwayFServ01AddSelectedDocuments,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_REMOVE_SELECTED_DOCUMENTS]: putAwayFServ01RemoveSelectedDocuments,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_SET_WORKSPACE_VISIBLE]: putAwayFServ01SetWorkspaceVisible,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_EXPORT_LOADING]: putAwayFServ01ExportLoading,
  [PutAwayFServ01Types.PUT_AWAY_F_SERV01_EXPORT_SUCCESS]: putAwayFServ01ExportSuccess
});
